<template>
  <div class="onboarding-status" :style="style">
    <span class="onboarding-status__label">{{ statusLabel }}</span>
  </div>
</template>

<script>
export default {
  name: "CellRendererOnboardingStatusLabel",
  computed: {
    statusState() {
      if (this.params.data.onboardingStatus === "active") {
        return true;
      }
      if (this.params.data.onboardingStatus === "inactive") {
        return false;
      }
      return null;
    },
    statusLabel() {
      if (this.statusState === true) {
        return "在籍中";
      }
      if (this.statusState === false) {
        return "退職済";
      }
      return "-";
    },
    style() {
      if (this.statusState === true) {
        return {
          backgroundColor: "#00BCD4",
          color: "#F2F2F2",
        };
      }
      if (this.statusState === false) {
        return {
          backgroundColor: "#F2F2F2",
          color: "#626262",
        };
      }
      return {
        backgroundColor: "#F2F2F2",
        color: "#626262",
      };
    },
  },
};
</script>

<style scoped lang="scss">
.onboarding-status {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 64px;
  padding: 2px 8px;
  border-radius: 4px;
}

.onboarding-status__label {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  white-space: nowrap;
}
</style>
